import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our Exceptional Web3 Development Services</h2>
            <p>
              As a trusted Web3 development agency, we offer a range of services
              to create products that meet your business goals and exceed your
              ROI. Our developers use the latest technologies to build
              error-free decentralized solutions with interactive features to
              fulfill your demands.
            </p>
            <p>
              Here are the Web3 application development services that we offer:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Web 3.0 Project Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom dApps Development</h4>
                  <p>
                    Our Web3 engineers build next-generation dApps to enable
                    Web3 apps using Rust, Solidity, Golang, and frameworks like
                    Substrate and Brownie. Our specialty is creating custom Web3
                    dApps that are highly interoperable, secure, and scalable.
                  </p>
                  <p>
                    Moreover, we constantly engage in thorough testing and
                    continual refining to ensure the dependability and
                    performance of our Web3 dApps.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Consulting Services</h4>
                  <p>
                    Our consultants make sure that your technology choices
                    easily support your business goals, from choosing the best
                    blockchain platform to drafting smart contracts and ensuring
                    strategic alignment. We work directly with you to create a
                    strategy that maximizes value for your company and your
                    users while assuring long-term growth and profitability.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Platform Development</h4>
                  <p>
                    The creative approach we have adopted when constructing the
                    Web3 platform goes beyond the standard site development. We
                    build scalable, safe, and dependable platforms that improve
                    user experiences by using blockchain technology, smart
                    contracts, and decentralized financing (DeFi).
                  </p>
                  <p>
                    To make sure your Web3 platform is tailored to your unique
                    business needs, our team helps you at every stage, from
                    design and development to deployment.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Integration Services</h4>
                  <p>
                    Our Web3 Integration Services enable you to integrate your
                    systems with decentralized technologies, such as blockchain,
                    smart contracts, and DeFi. Based on a strategic approach and
                    great performance, we uncover Web3 opportunities for your
                    organization adapted to your distinct business goals.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Games Development</h4>
                  <p>
                    With a feature-rich user experience, our web3 game
                    development service will take online gaming to a new level.
                    We provide a gaming environment where players are always in
                    control and free to engage in the decentralized market by
                    utilizing blockchain, smart contracts, and DeFi technology.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
